<tiime-input-container contentId="lastname" label="Nom" [errorMessage]="userForm.lastNameErrorMessage">
  <input
    id="lastname"
    type="text"
    placeholder="Nom"
    formControlName="lastName"
    autocomplete="off"
    [matAutocomplete]="userAutocomplete.autocomplete"
    #userLastNameInput
    data-cy="create-user-lastname-input"
  />
  <app-user-autocomplete
    #userAutocomplete="UserAutocomplete"
    [currentInputValue]="userForm.lastName.value"
    (selectRecord)="selectUserSuggestion($event)"
    [data]="users$ | async"
  ></app-user-autocomplete>
  @if (userForm.id.value) {
    <button
      tiimeSuffix
      tiime-button
      tiimeTooltip="Retirer le contact sélectionné"
      icon
      color="primary"
      (click)="deselectUserSuggestion()"
      (keydown)="deselectUserSuggestion()"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
</tiime-input-container>
<tiime-input-container contentId="firstname" label="Prénom" [errorMessage]="userForm.firstNameErrorMessage">
  <input
    id="firstname"
    type="text"
    placeholder="Prénom"
    formControlName="firstName"
    autocomplete="off"
    data-cy="create-user-firstname-input"
  />
</tiime-input-container>
<app-user-civility-select [control]="userForm.civility" [selectData]="civilities()"></app-user-civility-select>
<app-user-capacity-select
  [control]="userForm.capacity"
  [selectData]="capacities()"
  [errorMessage]="userForm.capacityErrorMessage"
></app-user-capacity-select>
<tiime-input-container contentId="phone" label="Téléphone" [errorMessage]="userForm.phoneErrorMessage">
  <input
    id="phone"
    type="tel"
    placeholder="Téléphone"
    formControlName="phone"
    autocomplete="off"
    data-cy="create-user-phone-input"
  />
</tiime-input-container>
<tiime-input-container contentId="email" label="Email" [errorMessage]="userForm.emailErrorMessage">
  <input
    id="email"
    type="email"
    placeholder="Email"
    formControlName="email"
    autocomplete="off"
    data-cy="create-user-email-input"
  />
</tiime-input-container>
